<script setup lang="ts">
import { redirectToPageNotFound } from '~/router'

onBeforeMount(() => {
  redirectToPageNotFound()
})
</script>

<template>
  <div />
</template>

<route lang="yaml">
name: index
meta:
  layout: empty
  requiresAuth: true
</route>
